import React, { useEffect, useState } from 'react'
import { getDatabase, ref, child, get } from "firebase/database";
import { databaseMiApp } from '../services/firebase-config';
import DetalleSimple from './DetalleSimple';
import DescargarApp from './DescargarApp';
import UDetalle from '../Objetos/UDetalle';
import { Alert, AlertTitle, Box } from '@mui/material';
import CopiarLink from './CopiarLink';
import UE from '../Objetos/UE';
import VerDetalleTorneo from './pages/VerDetallesTorneo';

export default function VerTorneo(props) {

  const [datosTorneo, setDatosTorneo] = useState(null);
  const [enCurso, setEncurso] = React.useState(false);
  const [mensaje, setMensaje] = React.useState("Buscando...");

  useEffect(() => {
    //recuperarTorneo(props.id);
  }, [props.id])


  return (
    <div>
      {
        props.id ?
          <div>
            <Box>
              <CopiarLink id={props.id} tipo={1} />
              <VerDetalleTorneo torneoId={props.id}/>
              <DescargarApp />
            </Box>
          </div>
          :
          null
      }
    </div>
  )
}